<template>
  <div>
    <Panel module="AI" :showFilter="false" :showSearch="false" :showButtons="false">
      <div slot="content-main">
        <AiChatConnection
          ref="connection"
          @connected="isOnline = true"
          @disconnected="isOnline = false"
          @message="onAiMessage"
        />

        <div class="ai-chat-wrapper">
          <div v-if="messages.length === 0" class="ai-welcome">
            <h1 class="ai-greeting">{{ greeting }}, {{ firstName }}</h1>
            <p class="ai-subtitle">Como posso ajudar você hoje?</p>
          </div>

          <div v-else class="ai-messages" ref="messagesBox">
            <AiMessageBubble
              v-for="(msg, i) in messages"
              :key="i"
              :text="msg.text"
              :from="msg.from"
            />
            <AiTypingIndicator :visible="typing" />
          </div>

          <div class="ai-input-section">
            <div class="ai-online-badge" :class="{ online: isOnline, offline: !isOnline }">
              <span class="ai-online-dot"></span>
              {{ isOnline ? 'Online' : 'Offline' }}
            </div>
            <AiChatInput ref="input" @send="onSend" />
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";
import { mapState } from "vuex";

import AiChatConnection from "../../../components/modules/ia/AiChatConnection.vue";
import AiChatInput from "../../../components/modules/ia/AiChatInput.vue";
import AiMessageBubble from "../../../components/modules/ia/AiMessageBubble.vue";
import AiTypingIndicator from "../../../components/modules/ia/AiTypingIndicator.vue";

export default {
  name: "Ai",

  components: {
    Panel,
    AiChatConnection,
    AiChatInput,
    AiMessageBubble,
    AiTypingIndicator,
  },

  data() {
    return {
      messages: [],
      typing: false,
      isOnline: false,
    };
  },

  computed: {
    ...mapState("user", ["userLogged"]),

    firstName() {
      const name = this.userLogged?.user?.name || this.userLogged?.user?.userName || "";
      return name.split(" ")[0];
    },

    greeting() {
      const hour = new Date().getHours();
      if (hour < 12) return "Bom dia";
      if (hour < 18) return "Boa tarde";
      return "Boa noite";
    },
  },

  methods: {
    onSend(text) {
      this.messages.push({ from: "user", text });
      this.typing = true;
      this.scroll();
      this.$refs.connection.send(text);
    },

    onAiMessage(text) {
      this.typing = false;
      this.messages.push({ from: "nixia", text });
      this.scroll();
    },

    scroll() {
      this.$nextTick(() => {
        const box = this.$refs.messagesBox;
        if (box) box.scrollTop = box.scrollHeight;
      });
    },
  },
};
</script>

<style scoped>
.ai-chat-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px);
  padding: 0;
}

.ai-welcome {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-bottom: 20px;
}

.ai-greeting {
  font-size: 40px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 12px;
  letter-spacing: -0.5px;
}

.ai-subtitle {
  font-size: 16px;
  color: #64748b;
  margin: 0;
}

.ai-messages {
  flex: 1;
  overflow-y: auto;
  padding: 24px 22% 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ai-input-section {
  padding: 0 22% 16px;
  flex-shrink: 0;
}

.ai-online-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;
  justify-content: flex-end;
  color: #94a3b8;
}

.ai-online-badge.online {
  color: #64748b;
}

.ai-online-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cbd5e1;
  display: inline-block;
}

.ai-online-badge.online .ai-online-dot {
  background: #f59e0b;
}

.dark-theme .ai-greeting {
  color: #e2e8f0;
}

.dark-theme .ai-subtitle {
  color: #94a3b8;
}
</style>
